import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../config/theme';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import WithdrawalItem from './WithdrawalItem';
import ResponsiveContainer from '../components/ResponsiveContainer';
import InfoMessage from '../components/InfoMessage';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../InnerApp';
import { trackEvent } from '../utils';

const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: '620px',
  },
  mainHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    marginBottom: '10px',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  lightningIcon: {
    top: 0,
    position: 'static',
    fontSize: '1.3rem',
    color: '#2D6E2F',
    fill: '#2D6E2F',
    marginRight: '6px',
  },
  title: {
    fontWeight: 700,
    marginBottom: 0,
    color: '#1A1A1A',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.5rem',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      position: 'static',
      transform: 'none',
      justifyContent: 'center',
    },
  },
  button: {
    color: '#2D6E2F',
    borderRadius: '10px',
    border: '1px solid #2D6E2F',
    backgroundColor: 'transparent',
    padding: '8px 14px',
    cursor: 'pointer',
    fontWeight: 600,
  },
  withdrawalRequests: {
    minHeight: '600px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E7F0',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    padding: '12px',
    marginTop: '12px',
  },
  info: {
    color: '#1A1A1A',
    margin: '20px',
    textAlign: 'center',
    fontSize: '110%',
    fontWeight: 600
  },
  footerAction: {
    marginTop: '10px',
    textAlign: 'center',
  }
}));

export default function Withdrawals({ currentUser, influencer }) {
  const { setCurrentUser } = useContext(UserContext);
  const classes = useStyles();
  const location = useLocation();
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(20);
  const [loading, setLoading] = useState(true);
  const [finalPage, setFinalPage] = useState(false);

  if (!currentUser)
    window.location.href = '/public/sign_in';

  async function fetchWithdrawalRequests(page) {
    setLoading(true);
    try {
      const response = await axios.get(`/api/v1/withdrawal_requests?page=${page}`);
      setFinalPage(response.data.length != perPage);
      if (page == 1)
        setWithdrawalRequests(response.data);
      else
        setWithdrawalRequests((prev) => prev.concat(response.data));
    } catch (error) {
      if (page == 1)
        setWithdrawalRequests([]);
    } finally {
      setLoading(false);
    }
  }
  async function fetchCurrentUser() {
    const response = await axios.get('/api/v1/customers/current');
    setCurrentUser(response.data);
  }

  function loadMore() {
    fetchWithdrawalRequests(currentPage + 1);
    setCurrentPage(currentPage + 1);
  }

  useEffect(() => {
    setCurrentPage(1);
    setFinalPage(false);
    fetchWithdrawalRequests(1);
    fetchCurrentUser();
  }, [location.key]);

  useEffect(() => {
    withdrawalRequests
      .filter((withdrawalRequest) => withdrawalRequest.status === 'approved')
      .forEach((withdrawalRequest) => {
        trackEvent(
          'Withdrawal',
          {
            value: parseFloat(withdrawalRequest.value),
            currency: 'BRL'
          },
          { identity: `approved:${withdrawalRequest.id}` }
        );
      });
  }, [withdrawalRequests]);

  return (
    <ThemeProvider theme={theme}>
      <ResponsiveContainer>
        <div className={classes.main}>
          <div className={classes.mainHeader}>
            <Typography variant="h5" className={classes.title}>
              <SvgIcon className={classes.lightningIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"></path>
              </SvgIcon>
              Meus Saques
            </Typography>
          </div>
          <div className={classes.withdrawalRequests}>
            {!loading && withdrawalRequests.map((withdrawalRequest) => (
              <WithdrawalItem key={withdrawalRequest.id} withdrawalRequest={withdrawalRequest} />
            ))}
            {loading && <div className={classes.info}>Carregando...</div>}
            {!loading && withdrawalRequests.length == 0 && <InfoMessage>Nenhum saque encontrado</InfoMessage>}
          </div>
          <div className={classes.footerAction}>
            {!finalPage && <button disabled={loading} className={classes.button} onClick={loadMore}>Carregar mais</button>}
          </div>
        </div>
      </ResponsiveContainer>
    </ThemeProvider>
  )
}